import { render, staticRenderFns } from "./CondoDocuments.vue?vue&type=template&id=3b37dca9&"
import script from "./CondoDocuments.vue?vue&type=script&lang=js&"
export * from "./CondoDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b37dca9')) {
      api.createRecord('3b37dca9', component.options)
    } else {
      api.reload('3b37dca9', component.options)
    }
    module.hot.accept("./CondoDocuments.vue?vue&type=template&id=3b37dca9&", function () {
      api.rerender('3b37dca9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/CondoDocuments.vue"
export default component.exports